module.exports = __webpack_public_path__ + "img/t4-5.909708d1.svg";